var map = {
	"./client.js": "zRZh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oE8f";


//////////////////
// WEBPACK FOOTER
// ./src/router/client nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = oE8f
// module chunks = 226